import BaseComponent from "./BaseComponent";

export default class VisibilityWrapper extends BaseComponent {
    /**
     * Wrapper to show or hide contents
     * @module VisibilityWrapper
     * @param {Object} props React props
     */
    constructor(props){
        super(props);
        this.state = {
            hidden: this.props.context.props.config[this.props.hideKey]
        };
        this.eventHandler = this.handleEvent.bind(this);
    }

    handleEvent(event) {
        if (event.type === "ev-switch-toggled") {
            this.setState({ hidden: this.props.context.props.config[this.props.hideKey] });
        }
    }

    componentWillMount() {
        document.addEventListener("ev-switch-toggled", this.eventHandler);
    }

    componentWillUnmount() {
        document.removeEventListener("ev-switch-toggled", this.eventHandler);
    }
   
    render(){
        return (
            <div className={ this.state.hidden ? "hidden" : "form-component-container"}>
                {this.props.children}
            </div>
        );
    }

    


}
